import translation from "./Languages.js";

// change web language and translation
const LANGUAGE = (state, language) => {
  state.language = language;
  state.translation = translation[language];
};

// music playlist
const MUSIC_PLAYLIST = (state, data) => {
  state.musicPlayList = data;
};

const HOMEPAGE = (state, data) => {
  state.homepageList = data;
};

const STATIC_CONTENT = (state, data) => {
  state.static_content = data;
};

const SLIDER = (state, data) => {
  state.sliderList = data;
};

const ANNOUNCEMENTS = (state, data) => {
  state.announcements = data;
};

const SEZENDEN = (state, data) => {
  state.sezenden_list = data;
};

const PRESS_LIST = (state, data) => {
  state.press_list = data;
};

const PRESS_EXTRA_IMAGES = (state, data) => {
  state.press_extra_images = data;
};

const ALLWORKS_HOME = (state, data) => {
  state.allwork_home = data;
};

const ALBUMS_LIST = (state, data) => {
  state.albums_list = data;
};

const ALBUM_TRACKLIST = (state, data) => {
  state.album_tracklist = data;
};

const ALBUM_IMAGES = (state, data) => {
  state.album_images = data;
};

const SELECT_OPTIONS = (state, data) => {
  state.select_options = data;
};

const SEARCH_SONGS = (state, data) => {
  state.search_song_list = data;
};
const EMPTY_SEARCH_SONGS = (state) => {
  state.search_song_list = [];
};

const PRODUCTS_LIST = (state, data) => {
  state.products_list = data;
};

const VIDEOPAGE_MENU = (state, data) => {
  let menu = {
    tr: {
      parent: [],
      child: [],
      params: [],
    },
    en: {
      parent: [],
      child: [],
      params: [],
    },
  };
  data.find((item) => {
    if (menu[item.textcontents_language]) {
      menu[item.textcontents_language].params.push({
        id: item.id,
        key: item.textcontents_key,
        position: item.position,
        language: item.textcontents_language,
      });

      // parent set
      if (item.parent_id == null) {
        let perm = data.filter((op) => {
          return item.id === op.id;
        })[0].textcontents_key;

        perm = perm.toLowerCase().replace(/\s/g, "_");

        menu[item.textcontents_language].parent.push({
          id: item.id,
          key: item.textcontents_key,
          link: perm,
          position: item.position,
        });
      } else {
        menu[item.textcontents_language].child.push({
          id: item.id,
          key: item.textcontents_key,
          parent: item.parent_id,
          position: item.position,
        });
      }
    }
  });

  translation.tr.videosMenu = menu.tr;
  translation.en.videosMenu = menu.en;
};

const VIDEOS_LIST = (state, data) => {
  state.videos_list = data;
};

const PHOTOSPAGE_MENU = (state, data) => {
  data = data.sort((a, b) => {
    return a.position - b.position;
  });
  translation.tr.photosMenu = data;
  translation.en.photosMenu = data;
};

const PHOTOS_LIST = (state, data) => {
  return (state.photos_list = data);
};

const UPDATES = (state, data) => {
  return (state.updates = data);
};

export default {
  LANGUAGE,
  MUSIC_PLAYLIST,
  HOMEPAGE,
  STATIC_CONTENT,
  SLIDER,
  ANNOUNCEMENTS,
  SEZENDEN,
  PRESS_LIST,
  PRESS_EXTRA_IMAGES,
  ALLWORKS_HOME,
  ALBUMS_LIST,
  ALBUM_TRACKLIST,
  ALBUM_IMAGES,
  SELECT_OPTIONS,
  SEARCH_SONGS,
  EMPTY_SEARCH_SONGS,
  PRODUCTS_LIST,
  VIDEOPAGE_MENU,
  VIDEOS_LIST,
  PHOTOSPAGE_MENU,
  PHOTOS_LIST,
  UPDATES,
};
